import { withInstall } from '@zoryn/utils'
import Countdown from './src/countdown.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCountdown: SFCWithInstall<typeof Countdown> =
  withInstall(Countdown)
export default ZCountdown

export * from './src/countdown'
